module.exports = __webpack_public_path__ + "img/pages.ece854f2.svg";